export const GRID_COLUMNS = 36;
export const GRID_ROWS = 21;
